'use client';

import { c as _c } from "react/compiler-runtime";
import { Div, PaperBlock, RootButton } from '@eon.cz/apollo13-frontend-common';
import { Typography } from '@mui/material';
import { LandingBackground } from 'modules/common/components/LandingBackground';
import Link from 'next/link';
import { redirect } from 'next/navigation';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
type Props = {
  statusCode: number;
};

/**
 * Komponenta zobrazí obsah s popisem chyby podle HTTP kódu, který obdrží.
 * Pro případ, kdy by uživatel přešel přímo na routu /_error, je to bráno jako chyba 404 (not found).
 * Routa /_error je dostupná přímo i v dev režimu.
 */
const ErrorPage: FC<Props> = t0 => {
  const $ = _c(12);
  const {
    statusCode
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const handleRootRedirect = _temp;
  const getTitleByStatusCode = _temp2;
  let t1;
  if ($[0] !== formatMessage) {
    t1 = code_0 => {
      switch (code_0) {
        case 200:
        case 404:
          {
            return <Typography><FormattedMessage id="error.http.hint" /></Typography>;
          }
        case 500:
          {
            return <><Typography><FormattedMessage id="error.http.internalServerErrorContent1" /></Typography><Typography><FormattedMessage id="error.http.hint" /></Typography><Typography><FormattedMessage id="error.http.internalServerErrorContent2" values={{
                  kontakt: <Link href={`mailto:${formatMessage({
                    id: "support.email"
                  })}`}>{formatMessage({
                      id: "support.email"
                    })}</Link>
                }} /></Typography></>;
          }
        default:
          {
            return <><Typography><FormattedMessage id="error.http.unexpectedContent1" /></Typography><Typography><FormattedMessage id="error.http.unexpectedContent2" /></Typography><Typography><FormattedMessage id="error.http.hint" /></Typography></>;
          }
      }
    };
    $[0] = formatMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getContentByStatusCode = t1;
  let t2;
  if ($[2] !== statusCode) {
    t2 = getTitleByStatusCode(statusCode);
    $[2] = statusCode;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      padding: 2
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== getContentByStatusCode || $[6] !== statusCode) {
    t4 = <Div sx={t3}>{getContentByStatusCode(statusCode)}</Div>;
    $[5] = getContentByStatusCode;
    $[6] = statusCode;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Div sx={{
      display: "flex",
      justifyContent: "flex-end"
    }}><RootButton onClick={handleRootRedirect} /></Div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t4) {
    t6 = <LandingBackground><PaperBlock titleBlock={t2} elevation={8}>{t4}{t5}</PaperBlock></LandingBackground>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default ErrorPage;
function _temp() {
  return redirect("/");
}
function _temp2(code) {
  switch (code) {
    case 200:
    case 404:
      {
        return <FormattedMessage id="error.http.notFoundTitle" />;
      }
    case 500:
      {
        return <FormattedMessage id="error.http.internalServerErrorTitle" />;
      }
    default:
      {
        return <FormattedMessage id="error.http.unexpectedTitle" />;
      }
  }
}